/**
 * UserResponse DTO - represents user profile data from backend.
 */
export class UserResponse {
  constructor(data = {}) {
    this.userId = data.userId || null;
    this.name = data.name || '';
    this.email = data.email || '';
    this.tenantId = data.tenantId || null;
    this.roles = Array.isArray(data.roles) ? data.roles : (data.role ? [data.role] : []);
    this.onboardingPending = Boolean(data.onboardingPending);
  }

  /**
   * Creates UserResponse from JSON object.
   * @param {Object} json - JSON object from API
   * @returns {UserResponse}
   */
  static fromJSON(json) {
    if (!json) {
      throw new Error('Cannot create UserResponse from null/undefined');
    }

    return new UserResponse({
      userId: json.userId,
      name: json.name,
      email: json.email,
      tenantId: json.tenantId,
      roles: json.roles,
      role: json.role,
      onboardingPending: json.onboardingPending,
    });
  }

  /**
   * Validates the user response.
   * @returns {boolean}
   */
  isValid() {
    return !!(this.userId && this.name && this.email && this.tenantId && this.roles.length > 0);
  }

  /**
   * Converts to plain object for storage.
   * @returns {Object}
   */
  toJSON() {
    return {
      userId: this.userId,
      name: this.name,
      email: this.email,
      tenantId: this.tenantId,
      roles: this.roles,
      onboardingPending: this.onboardingPending,
    };
  }
}
